// extracted by mini-css-extract-plugin
export default {"badgeImage":"badge_badgeImage__7WJ86"};